import { render, staticRenderFns } from "./YoutubeAnnouncementSettings.vue?vue&type=template&id=343b2166"
import script from "./YoutubeAnnouncementSettings.vue?vue&type=script&lang=js"
export * from "./YoutubeAnnouncementSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports